import { render, staticRenderFns } from "./mainFooter.vue?vue&type=template&id=d411f7b8&scoped=true&"
import script from "./mainFooter.vue?vue&type=script&lang=ts&"
export * from "./mainFooter.vue?vue&type=script&lang=ts&"
import style0 from "./mainFooter.vue?vue&type=style&index=0&id=d411f7b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d411f7b8",
  null
  
)

export default component.exports